import { useCallback } from 'react';
import { Button } from 'antd';
import { useConfig } from '@ohpen/react-utils';
import { useApiClient, UseApiClientOptions, useAuth } from '@ohpen/react-auth';
import { PageSpinner, NotFound, notification } from '@ohpen/enso-ui';

import * as pmpSdk from '@pmp/api';
import { AppLayout } from '@pmp/components';
import { AuthzProvider, PmpConfigProvider } from '@pmp/contexts';
import { Router } from '../../router';

export const AuthenticatedContent = () => {
  const config = useConfig();
  const auth = useAuth();

  const reload = useCallback(() => {
    if ('caches' in globalThis) {
      caches.keys().then(names => Promise.all(names.map(name => caches.delete(name))));
    }

    const url = new URL(globalThis.location.href);
    url.searchParams.set('_', Date.now().toString());
    globalThis.location.href = url.toString();
  }, []);

  const onVersionError = useCallback(() => {
    return
    notification().error({
      key: 'version-error',
      message: 'Version error',
      description: 'The version of the app you are using is outdated. Please reload the page to get the latest version.',
      placement: 'top',
      closeIcon: false,
      duration: 10,
      style: { background: '#fff' },
      btn: (
        <Button danger onClick={reload}>
          Reload
        </Button>
      ),
    });
  }, [reload]);

  const apiClientOptions: UseApiClientOptions = {
    config,
    version: config.VERSION,
    onVersionError,
    baseUrl: config?.APP?.apiBaseurl ?? '',
    client: pmpSdk.client,
    sdkModule: pmpSdk,
    getAccessToken: auth.getAccessToken,
  };

  const { isReady: apiClientReady, error: apiClientError } = useApiClient(apiClientOptions);

  if (!apiClientReady) {
    return <PageSpinner />;
  }

  if (apiClientError) {
    return <NotFound />;
  }

  return (
    <PmpConfigProvider getAccessToken={auth.getAccessToken}>
      <AuthzProvider>
        <AppLayout>
          <Router />
        </AppLayout>
      </AuthzProvider>
    </PmpConfigProvider>
  );
};
